module.exports = __webpack_public_path__ + "static/media/monitorIcon.svg";